<template>
  <div class="linha-passageiros-table d-flex flex-column pa-2">
    <v-alert v-if="!linha || !linha.id_linha" type="info" dense outlined>
      {{ $t('crudLinhas.detail.selectLine') }}
    </v-alert>
    <template v-else>
      <v-toolbar flat dense color="transparent" class="flex-grow-0 px-0 flex-wrap">
        <v-toolbar-title class="subtitle-1">
          {{ $t('crudLinhas.detail.passengers.title') }}
          <span v-if="passageiros.length" class="caption grey--text">({{ passageiros.length }})</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          v-if="canEdit"
          small
          color="primary"
          outlined
          class="mr-2"
          @click="$emit('allocate-group')"
        >
          <v-icon left small>mdi-account-group</v-icon>
          {{ $t('crudLinhas.detail.groupAllocation.open') }}
        </v-btn>
        <v-btn
          v-if="canEdit"
          small
          color="primary"
          class="mr-2"
          @click="$emit('allocate')"
        >
          <v-icon left small>mdi-account-plus</v-icon>
          {{ $t('crudLinhas.detail.allocation.open') }}
        </v-btn>
        <v-btn icon small @click="$emit('refresh')">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="passageiros"
        :loading="loading"
        dense
        class="elevation-1"
        :items-per-page="15"
        item-key="id_pessoa"
        :no-data-text="$t('crudLinhas.detail.passengers.empty')"
      >
        <template v-slot:item.sentidos="{ item }">
          <v-chip
            v-if="showDirectionChip(item, 'ida')"
            x-small
            class="mr-1"
            color="primary"
            text-color="white"
          >
            {{ $t('crudLinhas.detail.passengers.outbound') }}
          </v-chip>
          <v-chip
            v-if="showDirectionChip(item, 'volta')"
            x-small
            color="info"
            text-color="white"
          >
            {{ $t('crudLinhas.detail.passengers.inbound') }}
          </v-chip>
        </template>
        <template v-slot:item.boarding_label="{ item }">
          {{ fenceLabel(item, 'embarque') }}
        </template>
        <template v-slot:item.alighting_label="{ item }">
          {{ fenceLabel(item, 'desembarque') }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            v-if="canEdit"
            small
            class="mr-2"
            color="green"
            @click="$emit('edit-passenger', item)"
          >mdi-pencil</v-icon>
          <v-icon
            v-if="canEdit"
            small
            color="red"
            @click="$emit('deallocate', item)"
          >mdi-account-remove</v-icon>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
export default {
  name: "LinhaPassageirosTable",
  props: {
    linha: { type: Object, default: null },
    passageiros: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: false },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("crudLinhas.detail.passengers.name"), value: "nome_completo" },
        {
          text: this.$t("crudLinhas.detail.passengers.directions"),
          value: "sentidos",
          sortable: false,
        },
        { text: this.$t("crudLinhas.detail.passengers.group"), value: "nome_grupo" },
        { text: this.$t("crudLinhas.detail.passengers.unit"), value: "descricao_unidade" },
        { text: this.$t("crudLinhas.detail.passengers.boarding"), value: "boarding_label", sortable: false },
        { text: this.$t("crudLinhas.detail.passengers.alighting"), value: "alighting_label", sortable: false },
        { text: this.$t("validationSituation.headers.situation"), value: "nome_situacao_validacao" },
        { text: this.$t("crudLinhas.headers.sublines.actions"), value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    isFlagAlocado(flag) {
      return flag === 1 || flag === "1" || flag === true;
    },
    /**
     * Chip só se o passageiro está alocado naquele sentido nesta linha.
     * Não renderiza chip “vazio”/inativo para o sentido em que não está.
     */
    showDirectionChip(item, sense) {
      if (!item) return false;
      const idLinha =
        this.linha && this.linha.id_linha != null
          ? Number(this.linha.id_linha)
          : null;
      if (sense === "ida") {
        if (item.alocado_ida != null) {
          return this.isFlagAlocado(item.alocado_ida);
        }
        return (
          idLinha != null &&
          item.id_linha_ida != null &&
          Number(item.id_linha_ida) === idLinha
        );
      }
      if (sense === "volta") {
        if (item.alocado_volta != null) {
          return this.isFlagAlocado(item.alocado_volta);
        }
        return (
          idLinha != null &&
          item.id_linha_volta != null &&
          Number(item.id_linha_volta) === idLinha
        );
      }
      return false;
    },
    fenceLabel(item, kind) {
      if (!item) return "";
      const nome = item[`nome_cerca_${kind}`];
      const endereco = item[`endereco_${kind}`];
      const nomeStr = nome != null ? String(nome).trim() : "";
      if (nomeStr) return nomeStr;
      const endStr = endereco != null ? String(endereco).trim() : "";
      return endStr;
    },
  },
};
</script>
